import PromoSection from './PromoSection';

export { PromoSection };
export default PromoSection;
